<script setup lang="ts">
const userStore = useUserStore()
const { t } = useTranslation()
const { appEnv } = useEnvs()
const { isFecDomain } = useDomain()
const isDev = appEnv.value === 'dev'

const navigateToChangeEmail = () => {
  if (!isDev && isFecDomain)
    return location.href = `/kundenkonto/${userStore.user?.id}/email-andern/anfrage`

  if (userStore.userId)
    customNavigateTo({ name: 'kundenkonto-userId-email-andern-anfrage', params: { userId: userStore.userId } })
}
</script>

<template>
  <IaAlert
    v-if="userStore.user && !userStore.user?.isEmailConfirmed && !userStore.user?.isAccountOlderThan24hours"
    type="warning"
    class="rounded-unset"
    full-width
    text-class="w-full flex justify-center"
  >
    <span>
      {{ t('unverifiedUser.notVerified') }}
      <IaLink
        blank
        size="sm"
        font="700"
        underline
        no-margin
        as="button"
        @click="navigateToChangeEmail"
      >
        {{ t('unverifiedUser.resendEmail') }}
      </IaLink>
    </span>
  </IaAlert>
</template>

<style scoped>

</style>
